import { render, staticRenderFns } from "./QuoteLimitLowerRuleDia.vue?vue&type=template&id=4c7d5c9e&scoped=true"
import script from "./QuoteLimitLowerRuleDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitLowerRuleDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitLowerRuleDia.vue?vue&type=style&index=0&id=4c7d5c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d5c9e",
  null
  
)

export default component.exports